import _ from "lodash";
import {
  TableRow,
  TableCell,
  Typography,
  Paper,
  Grid,
  SvgIcon,
} from "@mui/material";
import columns from "./colums";
import PaginatedTable from "../../../utils/table/PaginatedTable";
import moment from "moment";
import { useNavigate } from "../../../utils/hooks";
import { ArrowForwardIosOutlined as ArrowForwardIosOutlinedIcon } from "@mui/icons-material";
import formatGender from "../../../utils/formatGender";

const notRowsMessage = "No hay pacientes para mostrar";

const RowGetter = ({ row: patients }) => {
  const navigate = useNavigate();
  const { id, name, surname, documentNumber, gender, birthDate } = patients;

  return (
    <>
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={id}
        onClick={() =>
          navigate(`/patients/${id}`, {
            state: { patient: patients },
          })
        }
      >
        <TableCell
          component="th"
          scope="row"
          align="left"
          sx={{ minWidth: 250 }}
        >
          {name || ""} {surname || ""}
        </TableCell>

        <TableCell component="th" scope="row" align="left">
          {documentNumber || ""}
        </TableCell>

        <TableCell component="th" scope="row" align="left">
          {formatGender(gender)}
        </TableCell>

        <TableCell component="th" scope="row" align="left">
          {birthDate && moment(birthDate).format("DD/MM/YYYY")}
        </TableCell>
      </TableRow>
    </>
  );
};

const CardGetter = ({ row: patients }) => {
  const navigate = useNavigate();
  const { id, name, surname, documentNumber, birthDate } = patients;

  return (
    <>
      <Paper
        variant="outlined"
        key={id}
        onClick={() =>
          navigate(`/patients/${id}`, {
            state: { patient: patients },
          })
        }
        sx={{ p: 1, mt: 1, mb: 1 }}
      >
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <Typography sx={{ fontWeight: 600 }}>
              {name} {surname}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <SvgIcon sx={{ color: "primary.main", fontSize: 18 }}>
              <ArrowForwardIosOutlinedIcon />
            </SvgIcon>
          </Grid>
        </Grid>

        <Grid container alignItems="center" mt={1.5}>
          <Grid item xs={6}>
            <Typography>DNI: {documentNumber}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography>
              FECHA DE NAC.:{" "}
              {birthDate && moment(birthDate).format("DD/MM/YYYY")}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

const PatientsTable = ({
  patients,
  loading,
  page,
  rowsPerPage,
  setPage,
  count,
  handleRequestSort,
}) => {
  function toRowOrderField(patients, sortingField) {
    const sortingFieldId = sortingField.id;
    const { id } = patients;
    switch (sortingFieldId) {
      case "id": {
        return parseInt(id, 10);
      }
      default: {
        return _.get(patients, sortingFieldId);
      }
    }
  }

  function handleChangePage(event, value) {
    setPage(value);
  }

  const pagination = {
    page,
    rowsPerPage,
    handleChangePage,
    count,
  };

  return (
    <PaginatedTable
      rows={patients}
      columns={columns}
      RowGetter={RowGetter}
      notRowsMessage={notRowsMessage}
      toRowOrderField={toRowOrderField}
      loading={loading}
      pagination={pagination}
      CardGetter={CardGetter}
      handleRequestSort={handleRequestSort}
    />
  );
};

export default PatientsTable;
